import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import SessionTimeout from './SessionTimeout';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);

  return (
    <div className="h-full flex flex-col min-h-screen bg-slate-50/50">
      <SessionTimeout />
      {/* Fixed navbar at the top */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      </div>

      {/* Main content area with sidebar */}
      <div className="flex min-h-screen pt-14">
        {/* Sidebar positioned relatively to allow space for footer */}
        <div className={`flex left-2 top-14 bottom-20 transition-all duration-300 ${
          isSidebarOpen ? 'w-64' : 'w-0 overflow-hidden'
        }`}>
          <Sidebar isOpen={isSidebarOpen} />
        </div>

        {/* Main content */}
        <div className={`flex-1 transition-all duration-300  mx-auto ${
          isSidebarOpen ? 'pl-55' : 'pl-0'
        }`}>
          <div className="p-6 pb-32">
            <Outlet />
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
